import { ThemeProvider } from "@mui/material/styles";
import { pdfTheme } from "./PdfStyles";
import Template1 from "../Template/FirstReport";
import Template2 from "../Template/SecondReport";
import Template3 from "../Template/ThirdReport";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     width: "100%",
//     backgroundColor: theme.palette.background.paper
//   },
//   reportheader: {
//     // backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.7).toRgbString(),
//     backgroundColor: theme.palette.primary.main,
//     padding: "36px",
//     color: "#FFFFFF",
//     textAlign: "center",
//     "& h1": {
//       fontWeight: 700,
//       fontSize: "20px",
//       marginBlock: "0px"
//     },
//     "& p": {
//       fontWeight: 400,
//       fontSize: "14px",
//       color: "#FFFFFF",
//       margin: "0px"
//     }
//   },
//   imageWrapper: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     height: "100%"
//   },
//   profiledata: {
//     textAlign: "left",
//     "& h6": {
//       fontWeight: 400,
//       fontSize: "12px",
//       marginBlock: "0px",
//       color: "#6D6D6D"
//     },
//     "& p": {
//       fontWeight: 400,
//       fontSize: "14px",
//       marginBlock: "0px",
//       color: "#344054"
//     }
//   },
//   profile: {
//     height: "80px",
//     border: "1px solid #FFFFFF",
//     "@media (max-width: 600px)": {
//       marginTop: "10px"
//     }
//   },
//   termdata: {
//     marginBlock: "20px",
//     width: "100%",
//     padding: "8px",
//     backgroundColor: theme.palette.primary.main,
//     "& h1": {
//       fontWeight: 700,
//       fontSize: "16px",
//       marginBlock: "0px",
//       textAlign: "center",
//       color: "#FFFFFF"
//     }
//   },
//   container: {
//     position: "relative",
//     backgroundColor: "#f9fafc",
//     borderRadius: 12,
//     padding: 10,
//     height: "100%",
//     border: "1px solid #e0e0e0"
//   },
//   templatetitle: {
//     fontWeight: 600,
//     marginBottom: "1.5rem",
//     fontSize: "1.25rem",
//     color: "#111"
//   },
//   card: {
//     borderRadius: 12,
//     overflow: "hidden",
//     border: "1px solid transparent",
//     transition: "all 0.3s ease",
//     cursor: "pointer",
//     "&:hover": {
//       borderColor: "#1976d2"
//     }
//   },
//   activeCard: {
//     borderColor: "#1976d2",
//     boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.3)"
//   },
//   mycards: {
//     padding: "10px",
//     marginRight: "10px",
//     borderRadius: "8px"
//   },
//   lockedCard: {
//     filter: "blur(2px)",
//     cursor: "not-allowed"
//   },
//   image: {
//     width: "100%",
//     height: "auto",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     padding: "1rem",
//     "& svg": {
//       width: "100%",
//       height: "auto",
//       maxHeight: 260,
//       objectFit: "contain"
//     }
//   },
//   templateName: {
//     textAlign: "center",
//     padding: "0.45rem 0",
//     fontWeight: 500,
//     fontSize: "0.95rem",
//     color: "#333",
//     margin: 0
//   },
//   locknote: {
//     width: "97%",
//     position: "absolute",
//     bottom: "10px",
//     right: "10px",
//     left: "10px",
//     display: "flex",
//     alignItems: "flex-start",
//     gap: "6px",
//     justifyContent: "flex-start",
//     textAlign: "left",
//     marginTop: "1.5rem",
//     background: "#fff",
//     padding: "0.75rem 1rem",
//     borderRadius: 8,
//     border: "1px dashed #ccc",
//     fontSize: "0.85rem",
//     color: "#555",
//     "& p": {
//       marginBlock: "0px"
//     }
//   },
//   titlediv: {
//     width: "100%",
//     height: "46px",
//     boxSizing: "border-box",
//     paddingLeft: "10px",
//     paddingRight: "10px",
//     border: "1px solid hsl(0, 0%, 80%)",
//     marginTop: "4px",
//     borderRadius: "6px",
//     backgroundColor: "white",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     color: "#667185",
//     "& input": {
//       border: "none",
//       outline: "none",
//       fontSize: "14px",
//       color: "#667185",
//       background: "transparent",
//       width: "100%"
//     } },
//   secondreportmain: {
//     position: "relative"
//   },
//   secondreportheader: {
//     // backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.7).toRgbString(),
//     // backgroundColor: "#E0E0E0",
//     padding: "36px",
//     color: theme.palette.primary.main,
//     textAlign: "center",
//     "& h1": {
//       fontWeight: 700,
//       fontSize: "20px",
//       marginBlock: "0px"
//     },
//     "& p": {
//       fontWeight: 400,
//       fontSize: "14px",
//       margin: "0px"
//     }
//   },
//   secondlogoContent: {
//     height: "50px"
//   },
//   stdninfo: {
//     paddingInline: "16px"
//   },
//   topBorderWrapper: {
//     position: "relative",
//     width: "100%",
//     height: "40px",
//     backgroundColor: "#fff",
//     overflow: "hidden"
//   },
//   topBorder: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     height: "40px",
//     width: "100%",
//     backgroundColor: theme.palette.primary.main,
//     clipPath: "polygon(0 0, 94% 0, 93% 40%, 0 40%)"
//   },
//   topBorderInner: {
//     position: "absolute",
//     top: 10,
//     right: 0,
//     height: "10px",
//     width: "100%",
//     backgroundColor: "#fff",
//     clipPath: "polygon(6% 0, 100% 0, 100% 100%, 7% 100%)"
//   },
//   secondtermdata: {
//     marginBlock: "20px",
//     width: "100%",
//     padding: "16px 8px 8px 8px",
//     // backgroundColor: theme.palette.primary.main,
//     "& h1": {
//       fontWeight: 700,
//       fontSize: "16px",
//       marginBlock: "0px",
//       textAlign: "center",
//       color: theme.palette.primary.main
//     }
//   },
//   tembottomimage: {
//     width: "100%",
//     fill: theme.palette.primary.main
//   },
//   borderleftright: {
//     borderLeft: `2px solid ${theme.palette.primary.main} `,
//     borderRight: `2px solid ${theme.palette.primary.main} `
//   },
//   linescontainer: {
//     display: "flex",
//     flexDirection: "column",

//     gap: "6px",
//     width: "100%",
//     // maxWidth: "400px",
//     alignItems: "center"
//   },
//   line1: {
//     height: "2.97px",
//     width: "60%",
//     backgroundColor: theme.palette.primary.main
//   },
//   line2: {
//     height: "2.97px",
//     width: "65%",
//     backgroundColor: theme.palette.primary.main
//   },
//   line3: {
//     height: "2.97px",
//     width: "60%",
//     backgroundColor: theme.palette.primary.main
//   }
// }), { defaultTheme: pdfTheme });

const PublishTemplateContent = ({ reportData, extraData, obtainablescore, profile, appLogo }) => {
  // const attendanceData = {
  //   total: reportData?.attendance?.total_days || 10,
  //   present: reportData?.attendance?.present_days || 8,
  //   absent: reportData?.attendance?.absent_days || 2
  // };

  const template = profile?.report_template?.template_id;

  return (
    <>
      {template === "template-1" ? (
        <Template1
          reportData={reportData}
          obtainablescore={obtainablescore}
          extraData={extraData}
          appLogo={appLogo}
          profile={profile}
        />
      ) : template === "template-2" ? (
        <Template2
          reportData={reportData}
          obtainablescore={obtainablescore}
          extraData={extraData}
          appLogo={appLogo}
          profile={profile}
        />
      ) : template === "template-3" ? (
        <Template3
          reportData={reportData}
          obtainablescore={obtainablescore}
          extraData={extraData}
          appLogo={appLogo}
          profile={profile}
        />
      ) :
        <Template1
          reportData={reportData}
          obtainablescore={obtainablescore}
          extraData={extraData}
          appLogo={appLogo}
          profile={profile}
        />
      }
    </>
  );
};

const PublishTemplate = (props) => (
  <ThemeProvider theme={pdfTheme}>
    <PublishTemplateContent {...props} />
  </ThemeProvider>
);

export const PublishTemplateForPDF = (props) => (
  <ThemeProvider theme={pdfTheme}>
    <PublishTemplateContent {...props} isPDF={true} />
  </ThemeProvider>
);

export default PublishTemplate;
